import React, { useState } from 'react';
import { 
  Dialog, DialogTitle, DialogContent, 
  DialogActions, TextField, Button 
} from '@mui/material';

const TextCaptureModal = ({ open, handleClose, handleSubmit, title, deftext }) => {
    const [inputValue, setInputValue] = useState(deftext);
    const [error, setError] = useState(false);

// Validation Logic
  const onConfirm = () => {
    if (inputValue.trim() === '') {
      setError(true); // Trigger error state
    } else {
      handleSubmit(inputValue);
      resetModal();
    }
  };
 
  const resetModal = () => {
    setInputValue('');
    setError(false);
    handleClose();
  };

  return (
    <Dialog open={open} onClose={resetModal} 
    // fullWidth maxWidth="sm"
    PaperProps={{
      sx:{
        width:'350px'
      }
    }}
 
 >
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>
        <TextField
          autoFocus
          multiline
          minRows={4}
          maxRows={10}
          margin="dense"
          label="Response"          
//          fullWidth
            sx={{ width: '100%' }}
          variant="outlined"
          value={inputValue}
          // The magic props for validation:
          error={error} 
          helperText={error ? "This field cannot be empty" : "Please enter text."}
          required
          onChange={(e) => {
            setInputValue(e.target.value);
            if (e.target.value.trim() !== '') setError(false); // Clear error while typing
          }}
        />
    </DialogContent>
    <DialogActions>
        <Button onClick={resetModal}>Cancel</Button>
        <Button 
          onClick={onConfirm} 
          variant="contained" 
          color={error ? "error" : "primary"}
        >
          Submit
        </Button>
    </DialogActions>
    </Dialog>
  )

}

export default TextCaptureModal;